import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "prod-offers__discount" };
const _hoisted_2 = { class: "prod-discount" };
const _hoisted_3 = { class: "prod-discount__wrap" };
const _hoisted_4 = { class: "prod-discount__cover" };
const _hoisted_5 = { class: "prod-discount__info" };
import Sprite from "../../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DiscountNote',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(Sprite, {
                                name: "discounts",
                                size: 32
                            })
                        ]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ])
                ])
            ]));
        };
    }
});
